import {createContext} from 'react';

const credentialsContext = createContext();

export default credentialsContext;